import { Component, OnInit } from '@angular/core';
import { jwtDecode } from 'jwt-decode';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-calendly',
  templateUrl: './calendly.component.html',
  styleUrls: ['./calendly.component.scss'],
})
export class CalendlyComponent implements OnInit {
  calendlyUrl: SafeResourceUrl = '';
  fullName = '';
  email = '';
  telephone = '';
  private readonly baseCalendlyUrl = 'https://calendly.com/a-calia/calia-landing-sales';

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    this.loadUserData();
  }

  loadUserData() {
    try {
      const storedData = JSON.parse(localStorage.getItem('dataUser') || '');
      const dataUser = jwtDecode(storedData.access_token) as any;

      if (!dataUser?.user?.first_name || !dataUser?.user?.last_name || !dataUser?.user?.email) return;

      this.fullName = `${dataUser.user.first_name} ${dataUser.user.last_name}`.trim();
      this.email = dataUser.user.email;
      this.telephone = dataUser.user.telephone ?? '';

      this.updateCalendlyUrl();
    } catch (error) {
      console.error('Error parsing dataUser from localStorage', error);
    }
  }

  updateCalendlyUrl() {
    const params = new URLSearchParams();
    if (this.fullName) params.append('name', this.fullName);
    if (this.email) params.append('email', this.email);
    if (this.telephone) params.append('a1', this.telephone);

    const url = `${this.baseCalendlyUrl}?${params.toString()}`;
    this.calendlyUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
